<template>

  <v-row align="center" justify="center" height="100vh" min-height="100vh" fill-height>
    <v-col align="center" justify="center">
      <WaitForCounselor />
    </v-col>
  </v-row>

</template>

<script>

import WaitForCounselor from "../components/WaitForCounselor.vue"

export default {
  name: 'MeetingView',
  components: {
    WaitForCounselor
  },
  data: () => ({
  
  }),

}

</script>